import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { RecollectionType } from 'src/app/@core/constants';
import { PosPrintDocumentsModalService } from 'src/app/@core/services/pos-print-documents-modal.service';
import { ColumnTable } from 'src/app/models/column-table';
import { Filter } from 'src/app/models/filter';
import { ReceiptFilter } from 'src/app/models/filters/receipt-filter';
import { Loan } from 'src/app/models/loan';
import { LoanInvoiceLine } from 'src/app/models/loan-invoice-line';
import { LoanReceiptInvoiceDetail } from 'src/app/models/loan-receipt-invoice-detail';
import { Paging } from 'src/app/models/page';
import { Receipt } from 'src/app/models/receipt';
import { RecollectionResponse } from 'src/app/models/recollection-response';
import { RecollectionRepairshopRequestModel, RecollectionRequestModel } from 'src/app/models/request/recollection-request-model';
import { CustomerService } from 'src/app/services/customer.service';
import { ReceiptsService } from 'src/app/services/receipts.service';

@Component({
  selector: 'app-customer-loans-detail',
  templateUrl: './customer-loans-detail.component.html',
  styleUrls: ['./customer-loans-detail.component.sass']
})
export class CustomerLoansDetailComponent implements OnInit {

  loan: Loan = new Loan();
  recollectionReceipts: Paging<Array<Receipt>> = new Paging([]);
  constructor(public bsModalRef: BsModalRef, private readonly customerService: CustomerService, private readonly posPrintDocumentsModalService: PosPrintDocumentsModalService, private readonly receiptService: ReceiptsService) { }

  async ngOnInit() {
    this.loan?.invoices.forEach(invoice => {
      invoice.pagingInvoiceLines = new Paging(invoice.invoiceLines);
    });

    await this.getData({ page: 0, pageSize: 10, value: { contractNumber: this.loan.contractNumber } });
  }

  getPaging(invoiceLines: Array<LoanInvoiceLine>): Paging<Array<LoanInvoiceLine>> {
    return new Paging(invoiceLines);
  }

  getInvoiceHeaders() {
    return [
      new ColumnTable("productCode", "Codigo"),
      new ColumnTable("productName", "Descripcion"),
      new ColumnTable("quantity", "Cantidad", { type: "number" }),
      new ColumnTable("grossTotal", "Total", { type: "currency" })
    ]
  }

  getHeaderText(invoice: LoanReceiptInvoiceDetail): string {
    return invoice.invoiceCode ? 'Factura' : 'Nota de Cargo';
  }


  getReceiptHeaders() {
    return [
      new ColumnTable("code", "Código de Recibo"),
      new ColumnTable("quota", "Cuota"),
      new ColumnTable("details.0.totals.netTotal", "Total", { type: "currency" }),
    ]
  }

  async getData(filter: Filter<ReceiptFilter>) {
    filter.value.contractNumber = this.loan.contractNumber;
    this.recollectionReceipts = (await this.receiptService.readReceipts(filter).toPromise()).response;

    this.recollectionReceipts.content = this.recollectionReceipts.content.map(m => {
      m.quota = m.details.find(f => f.contractNo == this.loan.contractNumber)?.contractData.quotas[0].number || "N/D";
      return m;
    })
  }

  printReceipt(receipt: Receipt) {
    this.posPrintDocumentsModalService.showPrintRecollectionDocuments(
      {
        branchCode: this.loan.branchCode,
        code: "",
        createdBy: "",
        createdOn: new Date(),
        customerCode: this.loan.customerCode,
        receipt: receipt,
        invoiceCode: "",
        loans: [],
        payments: [],
        recollectionOpenDocumentRequest: new RecollectionRepairshopRequestModel(),
        recollectionResponse: new RecollectionResponse(),
        recollectionType: RecollectionType.QUOTAS_PAYMENT,
        recollectioRequest: new RecollectionRequestModel(),
        salesOrg: this.loan.salesOrg,
        status: ""
      },
      {
        fullNumber: '',
        netTotal: 0,
        code: "",
        salesOrg: '',
      },
      undefined);
  }
}
